import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addResidentFailure,
  addResidentSuccess,
  //
  deleteResidentFailure,
  deleteResidentSuccess,
  //
  editResidentFailure,
  editResidentSuccess,
  //
  fetchResidents as fetchResidentAction,
  fetchResidentFailure,
  fetchResidentSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  //
  updateProfileFailure,
  updateProfileSuccess,
  //
  fetchBelongingsFailure,
  fetchBelongingsSuccess,
  //
  addBelongingFailure,
  addBelongingSuccess,
  //
  deleteBelongingFailure,
  deleteBelongingSuccess,
  //
  getResidentDataFailure,
  getResidentDataSuccess,
  //
  getDocStatusFailure,
  getDocStatusSuccess,
  //
  getTimelineFailure,
  getTimelineSuccess,
  //
  loadMoreTimelineFailure,
  loadMoreTimelineSuccess,
  //
  getMyAssessmentsFailure,
  getMyAssessmentsSuccess,
  //
  getOverviewFailure,
  getOverviewSuccess,
  //
  convertResidentFailure,
  convertResidentSuccess,
  //
  updateResidentStatusFailure,
  updateResidentStatusSuccess,
  //
  getTimelineInfoFailure,
  getTimelineInfoSuccess,
  //
  getPreAssessmentFailure,
  getPreAssessmentSuccess,
  //
  getAssessmentFormFailure,
  getAssessmentFormSuccess,
  //
  getDocQRCodeFailure,
  getDocQRCodeSuccess,
  // Add Pre Assessment
  addPreAssessmentFailure,
  addPreAssessmentSuccess,
  // Edit Pre Assessment
  editPreAssessmentFailure,
  editPreAssessmentSuccess,
} from "./actions";
import {
  ADD_RESIDENT,
  DELETE_RESIDENT,
  EDIT_RESIDENT,
  FETCH_RESIDENT,
  GET_VIEW_DATA,
  UPDATE_PROFILE,
  //
  FETCH_BELONGINGS,
  ADD_BELONGING,
  DELETE_BELONGING,
  //
  GET_RESIDENT_DATA,
  GET_DOC_STATUS,
  GET_TIMELINE,
  LOAD_MORE_TIMELINE,
  //
  GET_MY_ASSESSMENTS,
  GET_OVERVIEW,
  CONVERT_RESIDENT,
  UPDATE_RESIDENT_STATUS,
  GET_TIMELINE_INFO,
  GET_PRE_ASSESSMENT,
  GET_ASSESSMENT_FORM,
  GET_DOC_QR_CODE,
  ADD_PRE_ASSESSMENT,
  EDIT_PRE_ASSESSMENT,
} from "./constants";

export function* fetchResidentSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, isPreAssessment } = payload;

  let query = data ? QueryString.stringify(data) : "";

  try {
    const { data } = yield call(
      api(token).get,
      isPreAssessment
        ? `/api/pre-assessment-resident?${query}`
        : `/api/resident?${query}`,
    );
    yield put(fetchResidentSuccess(data));
  } catch (e) {
    yield put(fetchResidentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching residence!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/resident/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addResidentSaga({ payload, onAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).post, `/api/resident/add`, payload);
    if (data) {
      yield put(successAlert("Resident added successfully!"));
      yield put(addResidentSuccess());
      typeof onAdd === "function" && onAdd(data);
    }
  } catch (e) {
    yield put(addResidentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editResidentSaga({ payload, onEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/resident/edit/${payload.id}`,
      payload.data,
    );
    yield put(successAlert("Resident updated successfully!"));
    yield put(editResidentSuccess());
    yield put(getViewDataAction(payload.id));
    typeof onEdit === "function" && onEdit();
  } catch (e) {
    yield put(editResidentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteResidentSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/resident/${payload}`);
    if (data) {
      yield put(successAlert("Resident deleted successfully!"));
      yield put(deleteResidentSuccess());
      yield put(getViewDataSuccess(null));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteResidentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* updateProfileSaga({ payload, onUpdate }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/profile-picture/${payload.id}`,
      payload.data,
    );
    yield put(successAlert("Profile updated successfully!"));
    yield put(updateProfileSuccess());
    typeof onUpdate === "function" && onUpdate(data);
  } catch (e) {
    yield put(updateProfileFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchBelongingsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident-belonging?${query}`,
    );
    yield put(fetchBelongingsSuccess(data));
  } catch (e) {
    yield put(fetchBelongingsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}
export function* addBelongingSaga({ payload, onAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/resident-belonging/add`,
      payload,
    );
    yield put(addBelongingSuccess());
    typeof onAdd === "function" && onAdd();
  } catch (e) {
    yield put(addBelongingFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}
export function* deleteBelongingSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).delete,
      `/api/resident-belonging/${payload}`,
    );
    yield put(successAlert("Belonging deleted successfully!"));
    yield put(deleteBelongingSuccess());
    typeof onDelete === "function" && onDelete();
  } catch (e) {
    yield put(deleteBelongingFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getResidentDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident/${payload}/documents-data`,
    );
    yield put(getResidentDataSuccess(data));
  } catch (e) {
    yield put(getResidentDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* getDocStatusSaga({
  payload = { cancelToken: null },
  onDocStatus,
}) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident/${payload}/job-status`,
    );
    yield put(getDocStatusSuccess(data));
    typeof onDocStatus === "function" && onDocStatus(data);
  } catch (e) {
    yield put(getDocStatusFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* getTimelineSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const {
      id,
      page = 1,
      event_type,
      date_from,
      date_to,
      observation_log_type,
    } = typeof payload === "object" ? payload : { id: payload, page: 1 };

    let url = `/api/resident/${id}/timeline?page=${page}`;
    if (event_type) url += `&event_type=${event_type}`;
    if (date_from) url += `&date_from=${date_from}`;
    if (date_to) url += `&date_to=${date_to}`;
    if (observation_log_type && Array.isArray(observation_log_type)) {
      observation_log_type.forEach((type) => {
        if (type) url += `&observation_log_type[]=${type}`;
      });
    }

    const { data } = yield call(api(token).get, url);
    yield put(getTimelineSuccess(data));
  } catch (e) {
    yield put(getTimelineFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching timeline!"));
  }
}

export function* loadMoreTimelineSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { id, page, event_type, date_from, date_to, observation_log_type } =
      payload;

    let url = `/api/resident/${id}/timeline?page=${page}`;
    if (event_type) url += `&event_type=${event_type}`;
    if (date_from) url += `&date_from=${date_from}`;
    if (date_to) url += `&date_to=${date_to}`;
    if (observation_log_type && Array.isArray(observation_log_type)) {
      observation_log_type.forEach((type) => {
        if (type) url += `&observation_log_type[]=${type}`;
      });
    }

    const { data } = yield call(api(token).get, url);
    yield put(loadMoreTimelineSuccess(data));
  } catch (e) {
    yield put(loadMoreTimelineFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while loading more timeline!"));
  }
}

export function* getMyAssessmentsSaga({ payload, onGet }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/assessment-template/category-list/${payload}`,
    );
    yield put(getMyAssessmentsSuccess(data));
    typeof onGet === "function" && onGet(data);
  } catch (e) {
    yield put(getMyAssessmentsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching my assessments!"));
  }
}

export function* getOverviewSaga({ payload, onGet }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident/overview/${payload}`,
    );
    yield put(getOverviewSuccess(data));
    typeof onGet === "function" && onGet(data);
  } catch (e) {
    yield put(getOverviewFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching overview!"));
  }
}

export function* convertResidentSaga({ payload, onConvert }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/resident/convert-enquiry`,
      payload,
    );
    yield put(convertResidentSuccess());
    typeof onConvert === "function" && onConvert(data);
  } catch (e) {
    yield put(convertResidentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* updateResidentStatusSaga({ payload, onUpdate }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/resident/update-status/${payload.id}`,
      payload.data,
    );

    yield put(successAlert("Resident status updated successfully!"));
    yield put(updateResidentStatusSuccess());
    typeof onUpdate === "function" && onUpdate(data);
  } catch (e) {
    yield put(updateResidentStatusFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getTimelineInfoSaga({ payload, onGet }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, type } = payload;
  const apiConfig = {
    observation_log: `/api/observation-log/show/${id}`,
    assessment: `/api/resident-timeline-show/${id}`,
  };
  try {
    const { data } = yield call(api(token).get, `${apiConfig[type]}`);
    yield put(getTimelineInfoSuccess(data));
    typeof onGet === "function" && onGet(data);
  } catch (e) {
    yield put(getTimelineInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching timeline info!"));
  }
}

export function* getPreAssessmentSaga({ payload, onGet }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident-pre-assessment/${payload}`,
    );
    yield put(getPreAssessmentSuccess(data));
    typeof onGet === "function" && onGet(data);
  } catch (e) {
    yield put(getPreAssessmentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching pre assessment!"));
  }
}

export function* getAssessmentFormSaga({ payload, onGet }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/assessment-template?${query}`,
    );
    yield put(getAssessmentFormSuccess(data));
    typeof onGet === "function" && onGet(data);
  } catch (e) {
    yield put(getAssessmentFormFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching assessment form!"));
  }
}

export function* getDocQRCodeSaga({ payload, onGet }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location/qr-code/${payload}`,
    );
    yield put(getDocQRCodeSuccess(data));
    typeof onGet === "function" && onGet(data);
  } catch (e) {
    yield put(getDocQRCodeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching doc QR code!"));
  }
}

export function* addPreAssessmentSaga({ payload, onAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/pre-assessment-care-plan/save`,
      payload,
    );
    yield put(addPreAssessmentSuccess());
    yield put(
      successAlert(
        "Pre-assessment care plan has been saved successfully. The resident's pre-admission assessment is now on file.",
      ),
    );
    typeof onAdd === "function" && onAdd();
  } catch (e) {
    yield put(addPreAssessmentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(
        errorAlert(
          "Unable to save the pre-assessment care plan. Please check your connection and try again.",
        ),
      );
  }
}

export function* editPreAssessmentSaga({ payload, onEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, formData } = payload;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/pre-assessment-care-plan/update/${id}`,
      formData,
    );
    yield put(editPreAssessmentSuccess());
    yield put(
      successAlert(
        "Pre-assessment care plan has been updated successfully. Changes are saved.",
      ),
    );
    typeof onEdit === "function" && onEdit(data);
  } catch (e) {
    yield put(editPreAssessmentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(
        errorAlert(
          "Unable to update the pre-assessment care plan. Please check your connection and try again.",
        ),
      );
  }
}

export function* fetchResidentFlow() {
  yield takeEvery(FETCH_RESIDENT, fetchResidentSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addResidentFlow() {
  yield takeEvery(ADD_RESIDENT, addResidentSaga);
}
export function* editResidentFlow() {
  yield takeEvery(EDIT_RESIDENT, editResidentSaga);
}
export function* deleteResidentFlow() {
  yield takeEvery(DELETE_RESIDENT, deleteResidentSaga);
}
export function* updateProfileFlow() {
  yield takeEvery(UPDATE_PROFILE, updateProfileSaga);
}
export function* fetchBelongingsFlow() {
  yield takeEvery(FETCH_BELONGINGS, fetchBelongingsSaga);
}
export function* addBelongingFlow() {
  yield takeEvery(ADD_BELONGING, addBelongingSaga);
}
export function* deleteBelongingFlow() {
  yield takeEvery(DELETE_BELONGING, deleteBelongingSaga);
}
export function* getResidentDataFlow() {
  yield takeEvery(GET_RESIDENT_DATA, getResidentDataSaga);
}
export function* getDocStatusFlow() {
  yield takeEvery(GET_DOC_STATUS, getDocStatusSaga);
}
export function* getTimelineFlow() {
  yield takeEvery(GET_TIMELINE, getTimelineSaga);
}
export function* loadMoreTimelineFlow() {
  yield takeEvery(LOAD_MORE_TIMELINE, loadMoreTimelineSaga);
}
export function* getMyAssessmentsFlow() {
  yield takeEvery(GET_MY_ASSESSMENTS, getMyAssessmentsSaga);
}
export function* getOverviewFlow() {
  yield takeEvery(GET_OVERVIEW, getOverviewSaga);
}
export function* convertResidentFlow() {
  yield takeEvery(CONVERT_RESIDENT, convertResidentSaga);
}
export function* updateResidentStatusFlow() {
  yield takeEvery(UPDATE_RESIDENT_STATUS, updateResidentStatusSaga);
}
export function* getTimelineInfoFlow() {
  yield takeEvery(GET_TIMELINE_INFO, getTimelineInfoSaga);
}
export function* getPreAssessmentFlow() {
  yield takeEvery(GET_PRE_ASSESSMENT, getPreAssessmentSaga);
}
export function* getAssessmentFormFlow() {
  yield takeEvery(GET_ASSESSMENT_FORM, getAssessmentFormSaga);
}
export function* getDocQRCodeFlow() {
  yield takeEvery(GET_DOC_QR_CODE, getDocQRCodeSaga);
}
export function* addPreAssessmentFlow() {
  yield takeEvery(ADD_PRE_ASSESSMENT, addPreAssessmentSaga);
}
export function* editPreAssessmentFlow() {
  yield takeEvery(EDIT_PRE_ASSESSMENT, editPreAssessmentSaga);
}
export default function* ResidentSaga() {
  yield all([
    fetchResidentFlow(),
    addResidentFlow(),
    editResidentFlow(),
    deleteResidentFlow(),
    getViewDataFlow(),
    updateProfileFlow(),
    fetchBelongingsFlow(),
    addBelongingFlow(),
    deleteBelongingFlow(),
    getResidentDataFlow(),
    getDocStatusFlow(),
    getTimelineFlow(),
    loadMoreTimelineFlow(),
    getMyAssessmentsFlow(),
    getOverviewFlow(),
    convertResidentFlow(),
    updateResidentStatusFlow(),
    getTimelineInfoFlow(),
    getPreAssessmentFlow(),
    getAssessmentFormFlow(),
    getDocQRCodeFlow(),
    addPreAssessmentFlow(),
    editPreAssessmentFlow(),
  ]);
}
